import {Injectable} from '@angular/core';
import {Effect} from '@ngrx/effects';
import {Action} from '@ngrx/store';
import {environment} from '../../environments/environment';
import {DummyAction, SetAppContextAction} from '../store';
import {toCategory} from '../store/categories/Category';
import {AuthHttpService} from '../services/auth-http.service';
import {Observable, defer} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {LOCALE_PREFIX} from '../configs';
import {of} from 'rxjs';
import * as Raven from 'raven-js';
import {AppContext} from '../store/AppContext';

@Injectable()
export class AppContextEffect {
  @Effect()
  init$: Observable<Action> = defer(() => {
    return this.getAppContext();
  });

  constructor(private http: AuthHttpService) {}

  private getAppContext(): Observable<SetAppContextAction | DummyAction> {
    return this.http.get<any>(`${environment.urlPrefix}${LOCALE_PREFIX}/update_api/`).pipe(
      map((res: AppContext) => {
        Raven.setUserContext({
          email: res.user.email,
          id: res.user.id,
        });
        return new SetAppContextAction({
          cities: res.cities,
          categories: res.categories.map(toCategory),
          user: res.user,
          service: res.service,
        });
      }),
      catchError(() => {
        return of(new DummyAction());
      }),
    );
  }
}
